import actionCreatorFactory from 'typescript-fsa'

import {
  DeleteInstagramPostCommentRequest,
  GetInstagramPageFeedRequest,
  WriteInstagramPostCommentRequest,
} from '@3m5/sm_publish-frontend-api/apis/InstagramPostApi'
import { GetInstagramFeedResponse, InstagramPage, InstagramPost } from '@3m5/sm_publish-frontend-api/models'
import { GetInstagramPageRequest } from '@3m5/sm_publish-frontend-api/apis/InstagramPageApi'

const actionCreator = actionCreatorFactory('INSTAGRAM_POST')

/*
 * Actions
 */
export const getInstagramPageInitiated = actionCreator<GetInstagramPageRequest>('GET_INSTAGRAM_PAGE_INITIATED')
export const getInstagramPage = actionCreator.async<GetInstagramPageRequest, InstagramPage>('GET_INSTAGRAM_PAGE')

export const getIgPageFeedInitiated = actionCreator<{ data: GetInstagramPageFeedRequest, id: string }>('GET_IG_PAGE_FEED_INITIATED')
export const getIgPageFeed = actionCreator.async<GetInstagramPageFeedRequest, GetInstagramFeedResponse>('GET_IG_PAGE_FEED')

export const writeIgPostCommentInitiated = actionCreator<WriteInstagramPostCommentRequest>('WRITE_IG_POST_COMMENT_INITIATED')
export const writeIgPostComment = actionCreator.async<WriteInstagramPostCommentRequest, InstagramPost>('WRITE_IG_POST_COMMENT')

export const deleteInstagramPostCommentInitiated = actionCreator<DeleteInstagramPostCommentRequest>('DELETE_INSTAGRAM_POST_COMMENT_INITIATED')
export const deleteInstagramPostComment = actionCreator.async<DeleteInstagramPostCommentRequest, undefined>('DELETE_INSTAGRAM_POST_COMMENT')
